import React from "react";
import Layout from "../components/layouts/Layout";
import Block from "../components/Block";
import Link from "../components/Link";
import Styles from "../styles/404.module.css";
import { graphql, useStaticQuery } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { usePageContext } from "../backend/PageContext";
import SEO from "../components/seo";

const Error404 = () => {
  const { t } = useTranslation();
  const { lang } = usePageContext();
  const data = useStaticQuery(
    graphql`
      query {
        menuLinks: allMarkdownRemark(
          sort: {
            fields: frontmatter___order, 
            order: ASC
          }
        ) {
          nodes {
            fileAbsolutePath
            frontmatter {
              slug
              title
            }
          }
        }
        productLinks: allSyliusProduct(filter: {
          taxons: {
            main: {
              eq: "myesens_line"
            }
          }
        }) {
          nodes {
            name
            locale
            slug
          }
        }
      }
    `
  );

  const filteredProductLinks = data.productLinks.nodes.filter(
    link => link.locale === lang
  );

  const filteredMenuLinks = data.menuLinks.nodes.filter(
    link => link.fileAbsolutePath.indexOf(lang) > 0
  );
  
  return (
    <Layout>
      <SEO 
        title={t("404.title")}
      />
      <Block>
        <div className={Styles.container}>
          <h1 className={Styles.title}>{t("404.title")}</h1>
          <p className={Styles.content}>{t("404.content")}</p>
          <ul>
            <li>
              <Link to="/" className={Styles.link}>{t("headerFooter.ourPerfumes")}</Link>
            </li>
            {filteredProductLinks.map((link, i) =>
              <li key={i}>
                <Link 
                  to={`/products/${link.slug}`}
                  className={`${Styles.link} ${Styles.linkSmall}`}
                >
                  {link.name}
                </Link>
              </li>
            )}
            {filteredMenuLinks.map((link, i) =>
              <li key={i}>
                <Link 
                  to={`/pages/${link.frontmatter.slug}`}
                  className={Styles.link}
                >
                  {link.frontmatter.title}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </Block>
    </Layout>
  );
};

export default Error404;